import React, { useEffect } from 'react';

import "./ProfileButton.scss";
import { Profile } from '../Profile/Profile';
import { usePagePop } from '../../../hooks/usePagePop';
import { userBeam } from '../../../config/bifrost';
import { useBeam } from '@randajan/bifrost/client/react';

export const ProfileButton = (props)=>{
    const popProfile = usePagePop(<Profile/>, "hash.sign", "profile");

    const { data: profile } = useBeam(userBeam);

    useEffect(_=>{
        if (!profile || profile.subIsActive) { return; }

        popProfile.up();
    }, [profile]);

    return (
        <div className="ProfileButton" onClick={_=>popProfile.up()}>
            {props.children}
        </div>
    )
}

